// extracted by mini-css-extract-plugin
export default {"container":"PageContainer_container__LToO3","content":"PageContainer_content__VKDa8","draggable":"PageContainer_draggable__IUPJR"};